import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  root: {
    height: 'auto',
    maxHeight: '100vh',
    display: 'grid',
    gridTemplateColumns: '2fr 10fr',
    marginTop: 20,
    overflowY: 'scroll',
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
      display: 'none'
    }
  },
  rootSkeleton: {
    marginTop: 20
  }
}))

export default useStyles
